import React from 'react';
import './demoscontent.css';

const DemoPage: React.FC = () => {
  return (
    <main>

      {/* Shopify Demo Section */}
      <section className="demo-section">
        <h2 className="demo-title">Shopify E-Commerce Demo Store</h2>
        <p className="demo-paragraph">
          A fully functional Shopify demo store showcasing how small businesses can quickly scale their online sales using Shopify’s robust e-commerce platform.
        </p>
        <ul className="demo-list">
          <li>✅ Custom product listings and collections</li>
          <li>✅ Modern, mobile-friendly storefront</li>
          <li>✅ Integrated checkout and test payment flow</li>
          <li>✅ Branded theme and homepage layout</li>
          <li>✅ Shopify backend tools for inventory, orders, and customers</li>
        </ul>
        <p className="demo-paragraph">
          🔗 <strong>Visit the Demo Store:</strong><br />
          <a
            href="https://alvero-demo-shop.myshopify.com"
            target="_blank"
            rel="noopener noreferrer"
            className="demo-link"
          >
            https://alvero-demo-shop.myshopify.com
          </a><br />
          <strong>Password:</strong> alverodemo
        </p>
        <p className="demo-note">
          👉 <strong>Note:</strong> This store is password-protected as it is currently running in demo mode. Please enter the password to explore the live storefront and checkout flow.
        </p>
      </section>

      {/* Square Demo Section */}
      <section className="demo-section">
        <h2 className="demo-title">Square Online Demo for Service Businesses</h2>
        <p className="demo-paragraph">
          A live Square Online demo site showcasing how small service businesses can offer online booking, manage appointments, and accept payments with ease.
        </p>
        <ul className="demo-list">
          <li>✅ Service listings with pricing and descriptions</li>
          <li>✅ Online booking through Square Appointments</li>
          <li>✅ Mobile-friendly design for customer convenience</li>
          <li>✅ Customizable branding and color themes</li>
        </ul>
        <p className="demo-paragraph">
          🔗 <strong>Visit the Demo Site:</strong><br />
          <a
            href="https://alvero-demo-business.square.site"
            target="_blank"
            rel="noopener noreferrer"
            className="demo-link"
          >
            https://alvero-demo-business.square.site
          </a>
        </p>
        <p className="demo-note">
          👉 <strong>Note:</strong> This site is a live demo for showcasing service bookings and Square’s online tools. Feel free to explore the booking flow and test features.
        </p>
      </section>
    </main>
  );
};

export default DemoPage;
